import React, { useState } from "react";
import { useFlag } from "@unleash/proxy-client-react";
import { useTranslation } from "react-i18next";

import { Container } from "../../atoms/Container";
import { I18N_NAMESPACES, UNLEASH_BUILD_YOUR_OWN_ADVENT_CALENDAR } from "../../../helpers/constants";
import { useBuildYourOwn, useRemoveBuildYourOwn } from "../../../helpers/useBuildYourOwn";
import BuildYourOwnProgress from "../BuildYourOwnProgress";
import ConfirmationModal from "../ConfirmationModal";

/**
 * Shop-page banner shown while a build-your-own advent calendar is in progress:
 * nothing renders for everyone else. Sits under the wine pages' hero. Its close
 * X removes the calendar from the order, after a confirmation — the wines
 * stay. Once removed the banner unmounts, modal and all.
 */
const BuildYourOwnBanner = () => {
  const { t } = useTranslation([I18N_NAMESPACES.COMMON]);
  const { progress } = useBuildYourOwn();
  const { remove, isRemoving } = useRemoveBuildYourOwn();
  const isEnabled = useFlag(UNLEASH_BUILD_YOUR_OWN_ADVENT_CALENDAR);
  const [isConfirmingRemoval, setIsConfirmingRemoval] = useState(false);

  if (!isEnabled || !progress) return null;

  return (
    <Container>
      <BuildYourOwnProgress
        progress={progress}
        onRemove={() => setIsConfirmingRemoval(true)}
        isRemoving={isRemoving}
      />
      <ConfirmationModal
        isOpened={isConfirmingRemoval}
        title={t("common:buildYourOwn.removeConfirmTitle")}
        confirmLabel={t("common:buildYourOwn.removeConfirm")}
        cancelLabel={t("common:buildYourOwn.keepCalendar")}
        onConfirm={remove}
        onCancel={() => setIsConfirmingRemoval(false)}
        isConfirming={isRemoving}
        testId="build-your-own-remove-confirmation"
      >
        <p>{t("common:buildYourOwn.removeConfirmBody")}</p>
      </ConfirmationModal>
    </Container>
  );
};

export default BuildYourOwnBanner;
